import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';
export const StyledInputContainer = styled.div<SpaceProps>`
  direction: rtl;
  border: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 12px 16px 10px;
  ${space}
`;

export const StyledLabel = styled.label`
  color: ${({ theme }): string => theme.colors.minorText};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  margin-bottom: 12px;
`;

export const StyledInput = styled.input<{ type?: string }>`
  direction: ${({ type }): string => (type === 'email' ? 'ltr' : 'rtl')};
  width: 100%;
  margin-top: 5px;
  border: none;
  outline: none;
  font-family: ${({ type }): string =>
    type === 'email' ? 'AliBabaRE' : 'IRANSans-med'};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  color: ${({ theme }): string => theme.colors.normalText};
`;
